exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Xtu_-sYLn4UVwn5xZCGPI{font-size:14px;color:\"[theme:neutralSecondary, default:#666666]\"}._1Xtu_-sYLn4UVwn5xZCGPI.Y3NYnA2PnT2F8XsBu-1f5{color:#c50e2e}._26qDKnzbBLdq3WBCkcNp-9{font-size:12px;font-weight:400;color:\"[theme:themePrimary, default:#0078D4]\";cursor:pointer}html[dir] ._26qDKnzbBLdq3WBCkcNp-9{background:transparent}html[dir=ltr] ._1YOplGeWTxesnc82a36uRq{padding-right:5px}html[dir=rtl] ._1YOplGeWTxesnc82a36uRq{padding-left:5px}.GmOO6sOfzQPK6UCJypvy4{position:relative;top:-1px}", ""]);

// exports
exports.locals = {
	"sharingTipIcon": "_1Xtu_-sYLn4UVwn5xZCGPI",
	"error": "Y3NYnA2PnT2F8XsBu-1f5",
	"actionButton": "_26qDKnzbBLdq3WBCkcNp-9",
	"paddingRight": "_1YOplGeWTxesnc82a36uRq",
	"divider": "GmOO6sOfzQPK6UCJypvy4"
};